import { axiosPrivate } from './memoizedAxiosApi';

const loadDealByIdCustom = async (token, id, func) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  await axiosPrivate
    .get(
      `${
        import.meta.env.VITE_MAIN_LK_URL ?? 'https://stage.wizard24.ru'
      }/api/v1/orders/${encodeURIComponent(id)}`,
      config
    )
    .then((response) => func(response))
    .catch((error) => console.log('error', error));
};

const loadDocumentTypes = async (token, func) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  console.log(import.meta.env.VITE_MAIN_LK_URL);
  await axiosPrivate
    .get(
      `${
        import.meta.env.VITE_MAIN_LK_URL ?? 'https://stage.wizard24.ru'
      }/api/v1/documentTypes?filter[scope]=author`,
      config
    )
    .then((response) => func(response))
    .catch((error) => console.log('error', error));
};

export { loadDealByIdCustom, loadDocumentTypes };
